<div class="shell" [attr.data-sidebar]="uiService.sidebarMode()">
  <app-side-bar [menuData]="menu" />
  <app-main-header />

  <main class="body-wrapper" id="contenido">
    <div class="z-container">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
